"use client";

import React, { useState, useEffect, ReactNode, useRef } from "react";
import { Tooltip } from "@nextui-org/react";
import KatexComponent from "@/components/Katex";
import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
interface TooltipComponentProps extends GeneralPropsType {
  value?: string;
  useTooltipSlot?: boolean;
  noUseTranslate?: boolean;
  disableTooltip?: boolean;
  placement?: "top" | "bottom" | "left" | "right";
  children?: ReactNode;
  childrenTooltip?: ReactNode;
}
const TooltipComponent: React.FC<TooltipComponentProps> = ({
  value = "",
  useTooltipSlot = false,
  disableTooltip = false,
  placement = "top",
  className,
  onClick,
  children,
  childrenTooltip
}) => {
  const [contents, setContents] = useState<string[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const showTimeoutRef = useRef<any>();
  useEffect(() => {
    if (value && value.includes("use_tooltip-split-")) {
      const parts = value.split("-split-");
      setContents(parts.slice(1));
    } else {
      setContents([value || ""]);
    }
  }, [value]);
  const handleShowTooltip = () => {
    setIsOpen(true);
  };
  const handleHiddenTooltipRightAway = () => {
    setIsOpen(false);
  };
  const handleHiddenTooltip = () => {
    clearTimeout(showTimeoutRef.current);
    const tm = setTimeout(() => {
      setIsOpen(false);
      clearTimeout(tm);
    }, 2000);
  };
  return <Tooltip classNames={{
    content: "!bg-black !rounded-2xl text-[#fff]"
  }} content={!disableTooltip ? <div className={clsx("text-[1.3em] py-1", styles.container, className)}>
                        {childrenTooltip || contents[1] && <div>{contents[1]}</div>}
                        {contents[2] && <KatexComponent mathExpression={contents[2]} />}
                        {contents[3] && <div>{contents[3]}</div>}
                        {useTooltipSlot && children}
                    </div> : null} placement={placement} isOpen={isOpen && !disableTooltip}
  // onOpenChange={setIsOpen}
  data-sentry-element="Tooltip" data-sentry-component="TooltipComponent" data-sentry-source-file="index.tsx">
            <div className="tooltip-trigger" onClick={event => {
      onClick?.(event);
      if (isOpen) {
        handleHiddenTooltipRightAway();
      } else {
        handleShowTooltip();
        handleHiddenTooltip();
      }
      // setIsOpen((prev) => !prev);
    }}
    // onMouseEnter={handleShowTooltip}
    // onMouseLeave={handleHiddenTooltip}
    // onTouchStart={handleShowTooltip}
    // onTouchMove={handleHiddenTooltipRightAway}
    // onTouchEnd={handleHiddenTooltip}
    style={{
      cursor: "pointer",
      display: "inline-block"
    }}>
                {children || contents[0]}
            </div>
        </Tooltip>;
};
export default TooltipComponent;